import {apiConfig} from "@/store";

export const getSettings = () => apiConfig.request({
    endpoint: apiConfig.endpoints?.getSettings
});